// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-b5720c54]{height:100vh;overflow:auto}.app[data-v-b5720c54],.wrapper[data-v-b5720c54]{display:flex;flex-direction:column}.wrapper[data-v-b5720c54]{background-color:var(--color-white-dark);flex-grow:1;padding-bottom:4rem;position:relative}.content[data-v-b5720c54]{margin-left:auto;margin-right:auto;position:relative;width:100%}.ma-stack .ma-container--large[data-v-b5720c54]{--container-size:1600px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
